import { date_time_format } from "../assets/js/helpers";

export const helpersPlugin: any = {
  install(app: any, options: any) {
    app.config.globalProperties.$helpers = {};
    app.config.globalProperties.$helpers.date_time_format = date_time_format;
  },
};
